/**
 * WordPress Dependencies
 */
import classnames from 'classnames';
import { __ } from '@wordpress/i18n';
import { addFilter } from '@wordpress/hooks';
import { Fragment }	from '@wordpress/element';
import { InspectorAdvancedControls }	from '@wordpress/editor';
import { createHigherOrderComponent } from '@wordpress/compose';
import {
	PanelBody,
	PanelRow,
	Toolbar,
	SelectControl
} from '@wordpress/components';

import dt_responsive from './common';

//restrict to specific block names
const allowedBlocks = [ 'core/cover', 'core/group' ];


/**
 * Add mobile visibility controls on Advanced Block Panel.
 *
 * @param {function} BlockEdit Block edit component.
 *
 * @return {function} BlockEdit Modified block edit component.
 */
const withAdvancedControls = createHigherOrderComponent( ( BlockEdit ) => {
	return ( props ) => {
		const {
			name,
			attributes,
			setAttributes,
			isSelected,
			className,
		} = props;

		const {
			maskImgTop,
			maskImgBottom,
		} = attributes;

		let top_options = dt_gb_filters_data.svg_masks_top;
		let bottom_options = dt_gb_filters_data.svg_masks_bottom;

		return (
			<Fragment>
				<BlockEdit {...props} className={ className } />
				{ isSelected && allowedBlocks.includes( name ) &&
					<InspectorControls>
						<PanelBody
							title="Background Masks"
						>
							<PanelRow>
								<SelectControl
									label="Choose Top Mask"
									value={attributes.maskImgTop}
									options={top_options}
									onChange={(newval) => setAttributes({ maskImgTop: newval })}
								/>
							</PanelRow>
							<PanelRow>
								<SelectControl
									label="Choose Bottom Mask"
									value={attributes.maskImgBottom}
									options={bottom_options}
									onChange={(newval) => setAttributes({ maskImgBottom: newval })}
								/>
							</PanelRow>
						</PanelBody>
					</InspectorControls>
				}

			</Fragment>
		);
	};
}, 'withAdvancedControls');

addFilter(
	'editor.BlockEdit',
	'dubtempo/custom-advanced-control',
	withAdvancedControls
);


/**
 * Add custom attribute for mobile visibility.
 *
 * @param {Object} settings Settings for the block.
 *
 * @return {Object} settings Modified settings.
 */
function addAttributes( settings ) {

	//check if object exists for old Gutenberg version compatibility
	//add allowedBlocks restriction
	if( typeof settings.attributes !== 'undefined' && allowedBlocks.includes( settings.name ) ){

		settings.attributes = Object.assign( settings.attributes, {
			maskImgTop: {
				type: 'string',
				default: 'none',
			},
			maskImgBottom: {
				type: 'string',
				default: 'none',
			},
			responsiveSelector: {
				type: 'string',
				default: '',
			},
			responsiveCss: {
				type: 'string',
				default: '',
			}
		});

	}

	return settings;
}

addFilter(
	'blocks.registerBlockType',
	'dubtempo/custom-attributes',
	addAttributes
);


// Add classname to container in gutenberg


const withClientIdClassName = createHigherOrderComponent( ( BlockListBlock ) => {
    return ( props ) => {

    	// grab target attributes from props

		const {
			maskImgTop,
			maskImgBottom,
		} = props.attributes;

		// catch undefined classnames on block wrapper in editor

		var newClassNames;

		if (!props.className) {
			newClassNames = '';
		} else {
			newClassNames = props.className;
		}

		// clean and apply custom classnames

		if ( typeof maskImgTop !== 'undefined' && maskImgTop != '' ) {
			// remove previous class if it exists
		    var cleanClassTop = newClassNames.replace(/dt-gb-filters-mask__top[^"|'|\s]*/gmi, '');
			// add new class
			newClassNames = classnames( cleanClassTop, 'dt-gb-filters-mask__top--' + maskImgTop.replace(/^m-/, '') );
		}

		if ( typeof maskImgBottom !== 'undefined' && maskImgBottom != '' ) {
			// remove previous class if it exists
			var cleanClassBottom = newClassNames.replace(/dt-gb-filters-mask__bottom[^"|'|\s]*/gmi, '');
			// add new class
			newClassNames = classnames( cleanClassBottom, 'dt-gb-filters-mask__bottom--' + maskImgBottom.replace(/^m-/, '') );
		}

		// return wrapper block

        return <BlockListBlock { ...props } className={ newClassNames } />;
    };
}, 'withClientIdClassName' );

addFilter(
	'editor.BlockListBlock',
	'dubtempo/with-client-id-class-name',
	withClientIdClassName
);


// new attempt at responsive cover bgs

const responsiveCoverBg = createHigherOrderComponent( ( BlockListBlock ) => {

    return ( props ) => {

    	const {
    		backgroundType,
    		id,
    		url,
    	} = props.attributes;

    	if (backgroundType && id > 0 && url != '') {

		    var newClassNames = '';
		    var customclass = 'dt-gb-filters-resp-bg--' + id;

		    if (!props.className) {
		    	newClassNames = '';
		    } else {
		    	newClassNames = props.className;
		    }

		    jQuery.ajax({
		      type : "post",
		      async: false,
		      dataType : "json",
		      url : '/wp/wp-admin/admin-ajax.php',
		      data : {
		        action: "dt_gb_filters_get_attachment_image_responsive_css",
		        attachment_url : url,
		        custom_selector : customclass
		      },
		      success: function(response) {
		        if(response.responsive_css) {

				  // add responsive css to head
				  dt_responsive(customclass, response.responsive_css);

		          // add new classname to any current classnames
		          newClassNames = classnames( newClassNames, customclass );

		          // set props here and pass to save.js
		          props.attributes.className = props.attributes.className;
		          props.attributes.responsiveSelector = customclass;
		          props.attributes.responsiveCss = response.responsive_css;

		        } else {
		          console.error("No srcset for: " + id + "!")
		        }
		      }
		    });
    	}

		// return wrapper block
        return <BlockListBlock { ...props } className={ newClassNames } />;

    };
}, 'responsiveCoverBg' );

addFilter(
	'editor.BlockListBlock',
	'dubtempo/responsive-cover-bg',
	responsiveCoverBg
);
